import React from 'react';
import { Tabs, Badge } from 'antd-mobile';
import { withCookies } from 'react-cookie';

import MyListView from "./MyListView";

import { _getDataFormCount } from "../../server";

class HandlePage extends React.Component {

    myListView = [];
    hasFirstReceive = false;

    constructor(props) {
        super(props);

        let activeTap = window.sessionStorage.getItem("handle_active_tab");
        if (activeTap) {
            activeTap = parseInt(activeTap);
        } else {
            activeTap = 0;
        }

        const { cookies } = this.props;
        this.sid = cookies.get(process.env.TOKEN_KEY);
        this.state = {
            tabs: [
                { title: <Badge text={0}>待处理</Badge> },
                { title: <Badge>已处理</Badge> },
                { title: <Badge>我相关</Badge> },
            ],
            status: [0],
            listType: 3,
            activeTap: activeTap,
        }

        if(this.sid){
            this.getUntreatedCount();
        }
    }

    componentWillUnmount() {
        if (this.state.activeTap>=0) {
            window.sessionStorage.setItem("handle_active_tab", this.state.activeTap);
        }
    }

    bindRef_0 = ref => { this.myListView[0] = ref }
    bindRef_1 = ref => { this.myListView[1] = ref }
    bindRef_2 = ref => { this.myListView[2] = ref }

    componentWillReceiveProps() {
        const { cookies } = this.props;
        this.sid = cookies.get(process.env.TOKEN_KEY);
        if (!this.hasFirstReceive) {
            this.hasFirstReceive = true;
            return;
        }
        if (window.sessionStorage.getItem("index_tab") !== "handleTab") {
            return;
        }
        this.getUntreatedCount();
        this.myListView[this.state.activeTap].refreshList(-100, this.state.status, this.state.listType);
    }

    async getUntreatedCount() {
        const res = await _getDataFormCount(this.sid, 2);
        if (res.code === 0) {
            this.setState({
                tabs: [
                    { title: <Badge text={res.data.count}>待处理</Badge> },
                    { title: <Badge>已处理</Badge> },
                    { title: <Badge>抄送我</Badge> },
                ]
            });
        }
    }

    render() {
        return <Tabs tabBarActiveTextColor='#FF884D' 
                    tabBarUnderlineStyle={{border:'1px #FF884D solid'}} 
                    tabs={this.state.tabs} 
                    prerenderingSiblingsNumber={2}
                    initialPage={this.state.activeTap} 
                    useOnPan={false}
                    distanceToChangeTab={0.4}
                    onChange={(tab, index) => { 
                        switch (index) {
                            case 0:
                                this.setState({ status: [0], listType: 3, activeTap: 0 },
                                    () => setTimeout(this.myListView[0].refreshList(-100, this.state.status, this.state.listType), 20));
                                break;
                            case 1:
                                this.setState({ status: [1, 2], listType: 3, activeTap: 1 },
                                    () => setTimeout(this.myListView[1].refreshList(-100, this.state.status, this.state.listType), 20));
                                break;
                            case 2:
                                this.setState({ status: [0, 1, 2], listType: 4, activeTap: 2 },
                                    () => setTimeout(this.myListView[2].refreshList(-100, this.state.status, this.state.listType), 20));
                                break;
                            default:
                                console.log('onChange', index, tab);
                                break;
                        }
                    }}>
                    <div style={{alignItems: 'center',backgroundColor: '#fff', overflow: "hidden" }}>
                        <MyListView onRef={this.bindRef_0} status={[0]} formStatus="-100" listType={3} />
                    </div>
                    <div style={{alignItems: 'center',backgroundColor: '#fff', overflow: "hidden" }}>
                        <MyListView onRef={this.bindRef_1} status={[1, 2]} formStatus="-100" listType={3} />
                    </div>
                    <div style={{alignItems: 'center',backgroundColor: '#fff', overflow: "hidden" }}>
                        <MyListView onRef={this.bindRef_2} status={[0, 1, 2]} formStatus="-100" listType={4} />
                    </div>
                </Tabs>
    }
}

export default withCookies(HandlePage);